import { useState } from "react";
import { AlertCircle, Clock, CheckCircle2, ChevronRight } from "lucide-react";
import { tasks as initialTasks } from "../data/sampleData";

const priorityConfig = {
  high: { label: "高", color: "#ef4444" },
  medium: { label: "中", color: "#f59e0b" },
  low: { label: "低", color: "#10b981" },
};

const columnConfig = {
  todo: { label: "未着手", icon: <AlertCircle size={16} />, color: "#64748b" },
  inProgress: { label: "進行中", icon: <Clock size={16} />, color: "#f59e0b" },
  done: { label: "完了", icon: <CheckCircle2 size={16} />, color: "#10b981" },
};

export default function TaskBoard() {
  const [tasks, setTasks] = useState(initialTasks);

  const moveTask = (taskId, fromCol, toCol) => {
    if (fromCol === toCol) return;
    const task = tasks[fromCol].find((t) => t.id === taskId);
    setTasks((prev) => ({
      ...prev,
      [fromCol]: prev[fromCol].filter((t) => t.id !== taskId),
      [toCol]: [...prev[toCol], task],
    }));
  };

  return (
    <section>
      <h2 className="section-title">タスク管理</h2>
      <div className="kanban-board">
        {Object.entries(columnConfig).map(([colKey, col]) => (
          <div key={colKey} className="kanban-column">
            <div className="kanban-header" style={{ borderColor: col.color }}>
              <span style={{ color: col.color }}>{col.icon}</span>
              <span className="kanban-col-label">{col.label}</span>
              <span className="kanban-count">{tasks[colKey].length}</span>
            </div>
            <div className="kanban-cards">
              {tasks[colKey].map((task) => {
                const p = priorityConfig[task.priority];
                const otherCols = Object.keys(columnConfig).filter((k) => k !== colKey);
                return (
                  <div key={task.id} className="task-card">
                    <div className="task-top">
                      <span className="priority-dot" style={{ background: p.color }} title={`優先度：${p.label}`} />
                      <span className="task-client">{task.client}</span>
                    </div>
                    <p className="task-title">{task.title}</p>
                    <div className="task-bottom">
                      <span className="task-due">期限：{task.due}</span>
                      <div className="task-actions">
                        {otherCols.map((dest) => (
                          <button
                            key={dest}
                            className="move-btn"
                            title={`→ ${columnConfig[dest].label}`}
                            onClick={() => moveTask(task.id, colKey, dest)}
                          >
                            <ChevronRight size={13} />
                            {columnConfig[dest].label}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
